import { BrowserModule } from '@angular/platform-browser';
import { HttpClientModule, HTTP_INTERCEPTORS } from '@angular/common/http';
import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { DatePipe } from '@angular/common';

import { PaginationModule } from 'ngx-bootstrap/pagination';
import { BsDatepickerModule } from 'ngx-bootstrap/datepicker';
import { ModalModule } from 'ngx-bootstrap/modal';
import { TooltipModule } from 'ngx-bootstrap/tooltip';
import { ButtonsModule } from "ngx-bootstrap/buttons";
import { NgxSpinnerModule } from "ngx-spinner";

import { AppRoutingModule } from './app-routing.module';
import { AlertModule, AlertService } from "./shared/components/app-alert";
import { PagesModule } from './pages/pages.module';

import { ApiService } from './shared/services/api.service';
import { AuthenticationGuard } from './shared/services/authentication.guard';
import { AuthenticationService } from './shared/services/authentication.service';
import { EnvironmentService } from './shared/services/environment.service';
import { WaitingService } from './shared/services/waiting.service';
//import { AwsService } from './shared/services/aws.service';
import { ApiInterceptor } from './shared/services/api.interceptor';
import { SpinnerInterceptor } from './shared/services/spinner.interceptor';

import { AppComponent } from './app.component';
import { LoginComponent } from './login/login.component';
import { NavigationBarComponent } from './navigation-bar/navigation-bar.component';

import { MsalInterceptor, MsalModule, MsalRedirectComponent } from "@azure/msal-angular";
import { InteractionType, PublicClientApplication } from "@azure/msal-browser";
import { AADAuthenticationService } from './shared/services/aadauthentication.service';
import { SharedComponentsModule } from './shared/components/shared-components.module';

const isIE =
  window.navigator.userAgent.indexOf("MSIE ") > -1 ||
  window.navigator.userAgent.indexOf("Trident/") > -1;
@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    NavigationBarComponent
  ],
  imports: [
    BrowserModule,
    HttpClientModule,
    SharedComponentsModule,
    PaginationModule.forRoot(),
    BsDatepickerModule.forRoot(),
    ModalModule.forRoot(),
    TooltipModule.forRoot(),
    ButtonsModule.forRoot(),
    NgxSpinnerModule,
    AppRoutingModule,
    FormsModule,
    PagesModule,
    AlertModule,
    MsalModule.forRoot(
      new PublicClientApplication({
        auth: {
          clientId: "d7ec7cef-9cbd-4406-b9a2-8f386d76bee9", // Application (client) ID from the app registration
          authority:
            "https://login.microsoftonline.com/3c0f1beb-2a4a-4418-9270-8e9219bdc20e", // The Azure cloud instance and the app's sign-in audience (tenant ID, common, organizations, or consumers)
          redirectUri: "/", // This is your redirect URI
        },
        cache: {
          cacheLocation: "sessionStorage",
          storeAuthStateInCookie: isIE, // Set to true for Internet Explorer 11
        },
      }),
      null,
      {
        // MSAL Interceptor Configurations
        interactionType: InteractionType.Redirect,
        protectedResourceMap: new Map([ 
            ['https://graph.microsoft.com/v1.0/me', ['user.read']],
            ['/api/', ['api://d7ec7cef-9cbd-4406-b9a2-8f386d76bee9/all']]
        ])
      }
    ),
  ],
  providers: [
    AuthenticationService,
    AADAuthenticationService,
    AuthenticationGuard,
    DatePipe,
    AlertService,
    ApiService,
    EnvironmentService,
    WaitingService,
    //AwsService,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: MsalInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: ApiInterceptor,
      multi: true
    },
    {
      provide: HTTP_INTERCEPTORS,
      useClass: SpinnerInterceptor,
      multi: true
    }
  ],
  schemas: [
    CUSTOM_ELEMENTS_SCHEMA
  ],
  bootstrap: [AppComponent, MsalRedirectComponent]
})
export class AppModule { }
